module.exports = __webpack_public_path__ + "img/logo-wsj.88c765bc.svg";